<template>
  <div>
    <right-panel :datas="connects" :items="connects" @onClose="onCloseForm" @onSubmit="onSubmitAddForm" ref="right-panel-add">
      <div slot="header">
        <translate>Add SSH KEY</translate>
      </div>
    </right-panel>
  </div>
</template>

<script>
    import STORE_CONST from '../../../store/consts'
    import RightPanel from '../../common/right-panel'
    export default{
      name: 'AddSshkey',
      props: {
        items: {
          required: true
        }
      },
      data () {
        return {
          connects: null
        }
      },
      methods: {
        // 确定添加sshkey
        onSubmitAddForm () {
          let params = {
            data: this.$refs['right-panel-add'].profileModel
          }
          this.$store.dispatch(STORE_CONST.SSHKEY.ADD, params).then((res) => {
            this.$notify({
              message: this.$gettext('Add Successfully!'),
              type: 'success'
            })
            this.onCloseForm()
            this.$emit('callback')
            this.$refs['right-panel-add'].onSubmitErr()
          }).catch((err) => {
            console.log('err', err)
            this.$refs['right-panel-add'].onSubmitErr()
          })
        },
        // 关闭添加sshkey
        onCloseForm () {
          this.connects = null
          this.$emit('onClosePanel')
        }
      },
      watch: {
        'items': {
          handler: function (newVal) {
            if (this.connects) {
              this.connects = null
              setTimeout(() => {
                this.connects = this.items
              }, 300)
            } else {
              this.connects = this.items
            }
          },
          deep: true
        }
      },
      components: {
        RightPanel
      }
    }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// add-sshkey.vue?6b51e439